import { StandardEvents } from '@shopify/events';

class FangoCartFeedback extends HTMLElement {
  #controller;
  #revision = 0;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#onUpdate, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#revision += 1;
  }

  #onUpdate = (event) => {
    const revision = ++this.#revision;
    const status = this.querySelector('[data-fango-cart-status]');
    if (status) status.textContent = '';
    if (!event.promise || typeof event.promise.then !== 'function') return;
    event.promise.then(({ cart, detail }) => {
      if (!this.isConnected || revision !== this.#revision) return;
      const count = cart?.totalQuantity;
      if (!Number.isSafeInteger(count) || count < 0) return;
      const counter = this.querySelector('[data-fango-cart-count]');
      if (counter) counter.textContent = String(count);
      if (status && event.action === 'add' && detail?.didError === false) {
        status.textContent = this.dataset.addedMessage || '';
      }
    }).catch(() => {});
  };
}

if (!customElements.get('fango-cart-feedback')) customElements.define('fango-cart-feedback', FangoCartFeedback);
